import { Map } from "immutable"

export const dashboardBaseUrl = process.env.REACT_APP_DASHBOARD_URI
export const apiKey = process.env.REACT_APP_DASHBOARD_KEY

export let stakeholderBaseUrl

if (!process.env.REACT_APP_STAKEHOLDER_API_URL) {
    stakeholderBaseUrl = dashboardBaseUrl
} else {
    stakeholderBaseUrl = process.env.REACT_APP_STAKEHOLDER_API_URL
}

export function postJSONConfig(body, token) {
    return {
        headers: {
            ...(token ? getAuthHeader(token) : getApiKeyHeader()),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    }
}

export function postImageConfig(image, token) {
    const body = new FormData()
    body.append("image", image)
    return {
        headers: getAuthHeader(token),
        body,
    }
}

export function postAttachmentBody(fields) {
    const body = new FormData()

    for (const field in fields) {
        body.append(field, fields[field])
    }

    return body
}

export const getApiKeyHeader = () => ({
    "x-api-key": apiKey,
})

export const getAuthHeader = (token) => ({
    "X-Authorization": `Bearer ${token}`,
    ...getApiKeyHeader(),
})

export function getURLSearchParams(parameters) {
    const searchParams = new URLSearchParams()
    if (parameters) {
        if (Map.isMap(parameters)) {
            // process it as Immutable.Map
            parameters.forEach((value, key) => {
                if (Array.isArray(value)) {
                    value = value.join(",")
                }
                searchParams.append(key, value)
            })
        } else {
            // process it as a normal object
            Object.keys(parameters).forEach((key) => {
                let value = parameters[key]
                if (Array.isArray(value)) {
                    value = value.join(",")
                }
                searchParams.append(key, value)
            })
        }
    }
    return searchParams
}
